import React from 'react';

import { ConversionResults } from './ConversionResults';
import ConvertControls from './ConvertControls';

export function Convert() {
  return (
    <div>
      <ConvertControls />
      <ConversionResults />
    </div>
  );
}
